const durations = Object.freeze({
  MIN30: 2,
  MIN60: 5,
  MIN120: 8,
  MIN180: 21,
  MIN240: 9,
  MIN280: 20,
  MIN300: 10,
  MIN360: 11,
  MIN420: 12,
});

export default durations;
